<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex w-full justify-center min-h-screen">
  <p-stepper [value]="activeStep" class="basis-[100vw] flex-1 overflow-y-auto pb-20" [linear]="true">
    <p-step-list>
      <p-step [value]="1">Importar</p-step>
      <p-step [value]="2">Datos básicos</p-step>
      <p-step [value]="3">Completado</p-step>
    </p-step-list>
    <p-step-panels>
      <h1 class="mt-4 text-3xl font-semibold">Importar sedes</h1>

      <p-step-panel [value]="1">
        <ng-template #content>

          <form [formGroup]="form">

            <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">
              <div class="col-span-1 flex flex-col">
                <span class="text-black font-bold !text-base">Archivo</span>
                <span class="mt-1 text-sm text-gray-600">Selecciona o arrastra el archivo plantilla diligenciado, si no tienes la plantilla puedes descargarla en el siguiente link:</span>
                <span><a href="/assets/files/office-massive.xlsx" download="office-massive.xlsx" class="text-primary underline">Descargar plantilla</a></span>
              </div>

              <div class="max-w-lg flex flex-col gap-6">
                <div class="flex flex-col gap-2">
                  <label for="excel-file" class="text-black font-semibold">Archivo*</label>
                  <div class="card">
                    <p-fileupload
                      #fileUpload
                      id="excel-file"
                      accept=".xlsx ,.xls"
                      maxFileSize="52428800"
                      chooseLabel="Seleccionar"
                      (onSelect)="onSelectFile($event)"
                      invalidFileSizeMessageSummary="El peso máximo es de 50MB"
                      invalidFileTypeMessageSummary="Solo se aceptan archivos tipo XLSX y XLS"
                      [showUploadButton]="false"
                      [showCancelButton]="false"
                    >
                      <ng-template #empty>
                        <div class="flex flex-col items-center gap-4 w-full pb-8">
                          <span class="material-symbols-outlined text-black add-photo-icon">
                            add_photo_alternate
                          </span>
                          <span class="font-bold w-60 text-center text-black">
                            Arrasta tus archivos aquí o da clic en el botón seleccionar
                          </span>
                          <span class="text-sm text-gray-600">
                            Tamaño máximo: 50 MB
                          </span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="content" let-files>
                        @if (fileUrl) {
                          <div class="flex flex-row justify-between items-center w-full h-30">
                            <div class="flex content-center items-center">
                              <i class="pi pi-file-excel text-green-600 text-2xl"></i>
                              <span class="pl-4 truncate">
                                {{ fileName }}
                              </span>
                            </div>

                            <p-button
                              variant="text"
                              severity="danger"
                              icon="pi pi-times"
                              class="custom-button"
                              (onClick)="removeFile()">
                            </p-button>
                          </div>
                        }
                      </ng-template>
                    </p-fileupload>
                  </div>
                  <p-message severity="error" size="small" variant="simple">
                    {{ getErrorMessage('excel-file') }}
                  </p-message>
                </div>
              </div>
            </div>


          </form>

        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content>

          <form [formGroup]="form">

            <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">
              <div class="col-span-1 flex flex-col">
                <span class="text-black font-bold !text-base">Empresa de las sedes</span>
                <span class="mt-1 text-sm text-gray-600">Seleccione la empresa a la que harán parte las sedes que cree</span>
              </div>

              <div class="max-w-lg flex flex-col gap-6">
                <div class="flex flex-col gap-2">
                  <label for="businessId">Empresa*</label>
                  <p-select
                    [options]="getBusinessOptions()"
                    formControlName="businessId"
                    placeholder="Seleccione una empresa"
                    [invalid]="isInvalid('businessId')"
                    [filter]="true"
                    filterBy="label"
                    appendTo="body"
                    fluid
                  >
                    <ng-template #selectedItem let-selectedOption>
                      @if (selectedOption) {
                        <app-business-logo
                          [logoUrl]="selectedOption.logoUrl"
                          [name]="selectedOption.label"
                          logoSize="sm">
                        </app-business-logo>
                      }
                    </ng-template>
                    <ng-template let-business #item>
                      <app-business-logo
                        [logoUrl]="business.logoUrl"
                        [name]="business.label"
                        logoSize="sm">
                      </app-business-logo>
                    </ng-template>
                  </p-select>
                  @if (isInvalid('businessId')) {
                    <p-message severity="error" size="small" variant="simple">
                      {{ getErrorMessage('businessId') }}
                    </p-message>
                  }
                </div>
              </div>
            </div>

            <!-- Mostrar sedes si ya ha seleccionado una empresa -->
            @if (form.get('businessId')?.value) {

              <p-accordion [(value)]="activeAccordion">

                @for (officeForm of officesFormArray.controls; track $index; let i = $index) {
                    <p-accordion-panel [value]="i" class="my-4">
                      <p-accordion-header>
                        <!-- Se oculta icono de abrir/cerrar por defecto -->
                        <ng-template #toggleicon let-active="active"></ng-template>

                        <div class="flex items-center justify-between w-full">
                          <div class="flex items-center gap-2 cursor-pointer" (click)="activeAccordionChange(i)">
                            <span class="pi pi-chevron-right transition-transform duration-200" [class.rotate-45]="activeAccordion === i && activeAccordion !== null"></span>
                            <span>{{ getOfficeName(i) }}</span>
                          </div>
                          @if (officesFormArray.length > 1) {
                            <p-button
                              type="button"
                              severity="danger"
                              class="text-white rounded-full w-8 h-8 flex items-center justify-center transition-colors duration-200 ml-2"
                              (onClick)="removeOfficeForm(i); $event.stopPropagation()"
                            >
                              <i class="pi pi-times text-sm"></i>
                            </p-button>
                          }
                        </div>
                      </p-accordion-header>
                      <p-accordion-content>
                        <div class="grid grid-cols-[1fr_3fr] gap-10 mt-4 border border-solid border-gray-200 bg-white rounded-lg p-6">
                          <div class="col-span-1 flex flex-col">
                            <span class="text-black font-bold !text-base">Información general</span>
                            <span class="mt-1 text-sm text-gray-600 block">Formulario de información básica acerca de las sedes</span>
                          </div>

                          <div class="flex max-w-lg flex-col gap-6">
                            <div class="flex flex-col gap-2">
                              <label for="name{{i}}">Nombre*</label>
                              <input
                                pInputText fluid
                                id="name{{i}}"
                                [formControl]="getOfficeNameControl(i)"
                                placeholder="Ingrese el nombre de la sede"
                                [invalid]="isInvalid('name', i)"/>
                              @if (isInvalid('name', i)) {
                                <p-message severity="error" size="small" variant="simple">
                                  {{ getErrorMessage('name', i) }}
                                </p-message>
                              }
                            </div>

                            <div class="flex flex-col gap-2">
                              <label for="address{{i}}">Dirección*</label>
                              <input
                                pInputText fluid
                                id="address{{i}}"
                                [formControl]="getOfficeAddressControl(i)"
                                placeholder="Ingrese la dirección"
                                [invalid]="isInvalid('address', i)"/>
                              @if (isInvalid('address', i)) {
                                <p-message severity="error" size="small" variant="simple">
                                  {{ getErrorMessage('address', i) }}
                                </p-message>
                              }
                            </div>

                            <div class="flex flex-col gap-2">
                              <label for="country{{i}}">País*</label>
                              <p-select
                                [options]="countryOptions"
                                [formControl]="getOfficeCountryControl(i)"
                                placeholder="Seleccione un país"
                                [invalid]="isInvalid('country', i)"
                                [filter]="true"
                                optionValue="iso2"
                                filterBy="name"
                                appendTo="body"
                                fluid
                              >
                                <ng-template #selectedItem let-selectedOption>
                                  @if (selectedOption) {
                                    <div class="flex items-center gap-2">
                                      <app-flag-image
                                        [countryIso2]="selectedOption.iso2"
                                        size="sm"
                                      />
                                    </div>
                                  }
                                </ng-template>
                                <ng-template let-country #item>
                                  <div class="flex items-center gap-2">
                                    <app-flag-image
                                      [countryIso2]="country.iso2"
                                      size="sm"
                                    />
                                  </div>
                                </ng-template>
                              </p-select>
                              @if (isInvalid('country', i)) {
                                <p-message severity="error" size="small" variant="simple">
                                  {{ getErrorMessage('country', i) }}
                                </p-message>
                              }
                            </div>

                            <div class="flex flex-col gap-2">
                              <label for="state{{i}}">Región</label>
                              <input
                                pInputText fluid
                                id="state{{i}}"
                                [formControl]="getOfficeStateControl(i)"
                                placeholder="Ingrese la región"/>
                            </div>

                            <div class="flex flex-row gap-2">
                              <p-checkbox inputId="isMain{{i}}" [binary]="true" [formControl]="getOfficeIsMainControl(i)"/>
                              <label for="isMain{{i}}" class="ml-2">Sede principal</label>
                            </div>
                          </div>
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                }

              </p-accordion>
            }

          </form>

        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="3">
        <ng-template #content>
          <div class="flex flex-col items-center justify-center mt-10 gap-6">
            <i class="pi pi-check-circle text-green-600 text-6xl"></i>
            <h2 class="text-2xl font-semibold text-center">¡Sedes creadas exitosamente!</h2>
            <p class="text-center text-gray-700 max-w-md">
              Las sedes han sido creadas correctamente. Haz clic en "Finalizar" para volver al listado de sedes.
            </p>
            <p-button
              label="Finalizar"
              icon="pi pi-check"
              (onClick)="onClickCancel()"
              class="w-40"
            ></p-button>
          </div>
        </ng-template>

      </p-step-panel>

    </p-step-panels>
  </p-stepper>

  <app-form-footer>
    @if (activeStep < 3) {
      <div class="flex flex-row justify-between gap-2 w-full">
        <div class="justify-start">
          @if (form.get('businessId')?.value) {
            <p-button
              fluid
              label="Crear otra sede"
              (onClick)="addOfficeForm()"
              class="w-40 justify-start items-start justify-self-start"
            ></p-button>
          }
        </div>

        <div class="flex flex-row gap-2 justify-end">
          <p-button
            fluid
            label="Cancelar"
            variant="text"
            severity="primary"
            (onClick)="onClickCancel()"
            class="w-30"
          ></p-button>

          <p-button
            fluid
            label="Regresar"
            (onClick)="onClickPreviousStep()"
            severity="secondary"
            [disabled]="isFirstStep()"
            class="w-30"
          ></p-button>

          <p-button
            fluid
            label="Siguiente"
            (onClick)="onClickNextStep()"
            [disabled]="shouldDisableNextButton()"
            class="w-30"
          ></p-button>
        </div>
      </div>
    }
  </app-form-footer>

  <p-toast />
</div>

<app-dialog
  [(visible)]="visibleSuccessDialog"
  type="success"
  [title]="dialogTitle"
  [message]="dialogMessage"
  buttonText="Confirmar"
  (onButtonClick)="onCloseDialog()">
</app-dialog>
